<template>
  <div class="page">
    <!-- 搜索区：与 TimeEfficiencyListReq 接口字段对应 -->
    <div class="filter-container">
      <el-form :inline="true" :model="queryParams" label-width="90px">
        <el-form-item label="问题序号">
          <el-input v-model="queryParams.questionNum" placeholder="请输入" clearable />
        </el-form-item>
        <el-form-item label="反馈单号">
          <el-input v-model="queryParams.feedbackFormId" placeholder="请输入" clearable />
        </el-form-item>
        <el-form-item label="国家">
          <el-input v-model="queryParams.country" placeholder="请输入国家名称" clearable />
        </el-form-item>
<!--        <el-form-item label="故障描述">
          <el-input v-model="queryParams.questionContent" placeholder="请输入" clearable />
        </el-form-item>-->
        <el-form-item label="反馈人">
          <el-input v-model="queryParams.creator" placeholder="请输入" clearable />
        </el-form-item>
        <el-form-item label="反馈时间">
          <el-date-picker
            v-model="feedbackTimeRange"
            type="daterange"
            range-separator="-"
            value-format="yyyy-MM-dd"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            style="width: 240px"
          />
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="queryParams.status" placeholder="请选择" clearable filterable style="width: 140px">
            <el-option label="待提交" value="0" />
            <el-option label="处理中" value="1" />
<!--            <el-option label="待经销商确认" value="WAITING" />-->
            <el-option label="已驳回" value="3" />
            <el-option label="已关闭" value="4" />
          </el-select>
        </el-form-item>
        <!-- 操作：与 dataReport 一致，用 form-item 包裹保证按钮可见 -->
        <el-form-item label=" ">
          <el-button type="primary" size="small" @click="doSearch">查询</el-button>
          <el-button type="primary" plain size="small" @click="handleResetQuery">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="table-container">
      <!-- highlight-current-row
      :header-cell-style="{ background: '#EFEFEF', color: '#000' }"
      :border="true" -->
      <div class="table-btn">
        <el-button
          type="text"
          size="mini"
          icon="el-icon-download"
          @click="exportToExcel"
          :loading="exportLoading"
          >导出</el-button
        >
      </div>
      <el-table :data="tableData" style="width: 100%" stripe border :loading="tableLoading">
        <!-- 第一行表头=角色(空)，第二行=问题序号 -->
        <el-table-column align="center" width="100">
          <template slot="header"><span></span></template>
          <el-table-column prop="questionNum" label="问题序号" align="center" />
        </el-table-column>
        <el-table-column align="center" width="120">
          <template slot="header"><span></span></template>
          <el-table-column prop="feedbackFormId" label="反馈单号" align="center" />
        </el-table-column>
        <el-table-column align="center" width="80">
          <template slot="header"><span></span></template>
          <el-table-column prop="area" label="地区" align="center" width="80" />
        </el-table-column>
        <el-table-column align="center" width="100">
          <template slot="header"><span></span></template>
          <el-table-column prop="country" label="国家" align="center" />
        </el-table-column>
        <el-table-column align="center" min-width="160">
          <template slot="header"><span></span></template>
          <el-table-column prop="questionContent" label="故障描述" align="center" min-width="160" show-overflow-tooltip />
        </el-table-column>
        <el-table-column align="center" width="100">
          <template slot="header"><span></span></template>
          <el-table-column prop="creator" label="反馈人" align="center" />
        </el-table-column>
        <el-table-column align="center" width="160">
          <template slot="header"><span></span></template>
          <el-table-column prop="submitTime" label="反馈时间" align="center" />
        </el-table-column>
        <el-table-column align="center" width="120">
          <template slot="header"><span></span></template>
          <el-table-column prop="responseTime" label="响应时效" align="center" />
        </el-table-column>
        <!-- 第一行=技术经理，第二行=临时措施输出时效 -->
        <el-table-column label="技术经理" align="center" width="140">
          <el-table-column prop="technologyManagerTemporaryMeasureOutputTime" label="临时措施输出时效" align="center" />
        </el-table-column>
        <el-table-column label="服务经理" align="center" width="140">
          <el-table-column prop="serviceManagerTemporaryMeasureConfirmTime" label="临时措施确定时效" align="center" />
        </el-table-column>
        <el-table-column label="责任单位" align="center" width="140">
          <el-table-column prop="responsibleUnitRootCauseAnalysisOutputTime" label="根因分析输出时效" align="center" />
        </el-table-column>
        <el-table-column label="QE" align="center" width="140">
          <el-table-column prop="qeRootCauseAnalysisConfirmTime" label="根因分析确定时效" align="center" />
        </el-table-column>
        <el-table-column label="责任单位" align="center" width="140">
          <el-table-column prop="responsibleUnitPermanentMeasureOutputTime" label="永久措施输出时效" align="center" />
        </el-table-column>
        <el-table-column label="QE" align="center" width="140">
          <el-table-column prop="qePermanentMeasureConfirmTime" label="永久措施确定时效" align="center" />
        </el-table-column>
        <el-table-column label="QE" align="center" width="140">
          <el-table-column prop="qeBreakpointConfirmTime" label="断点确认时间" align="center" />
        </el-table-column>
      </el-table>

      <!-- ------------------------------------------ -->

      <div class="fenye">
        <pagination
          :total="total"
          :page.sync="pageNum"
          :limit.sync="pageSize"
          @pagination="handlePaginationChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import listCurd from "@/mixins/listCurd";
import * as XLSX from "xlsx";
// import XLSX from 'xlsx-style';
import ProblemList from "./components/problemList.vue";
import { getDownloadFiles } from "@/util/downFile";
import {
  timeEfficiencyPageApi,
  timeEfficiencyPageApiExport,
} from "@/api/feedback.js";

// /timeEfficiencyPage
export default {
  components: { ProblemList },
  mixins: [listCurd],

  data() {
    const { pageNum, pageSize } = "";

    return {
      type: "timelinessReport",
      exportLoading: false,
      tableData: [],
      listMethod: timeEfficiencyPageApi,
      pageNum: Number(pageNum) || 1,
      pageSize: Number(pageSize) || 10,
      /** 与 TimeEfficiencyListReq 一致，供 listCurd.getParams() 使用 */
      queryParams: {
        questionNum: "",
        feedbackFormId: "",
        country: "",
        questionContent: "",
        creator: "",
        startTime: "",
        endTime: "",
        status: "",
      },
    };
  },
  computed: {
    /** 反馈时间范围，与 queryParams.startTime/endTime 双向同步 */
    feedbackTimeRange: {
      get() {
        if (this.queryParams.startTime && this.queryParams.endTime) {
          return [this.queryParams.startTime, this.queryParams.endTime];
        }
        return null;
      },
      set(val) {
        if (val && val.length === 2) {
          this.queryParams.startTime = val[0];
          this.queryParams.endTime = val[1];
        } else {
          this.queryParams.startTime = "";
          this.queryParams.endTime = "";
        }
      },
    },
  },
  created() {
    this.getList();
  },
  methods: {
    /** 覆盖 mixin：枚举等字段为空时不传空字符串，只传有值的参数 */
    getParams() {
      const data = { ...this.queryParams };
      Object.keys(data).forEach((key) => {
        if (data[key] === "") {
          delete data[key];
        }
      });
      return {
        data,
        page: {
          pageNum: this.pageNum,
          pageSize: this.pageSize,
        },
      };
    },
    async exportToExcel() {
      this.btnLoading = true;
      this.exportLoading = true;
      try {
        const query = this.getParams();
        const res = await timeEfficiencyPageApiExport(query);
        getDownloadFiles(res, "质量反馈管理-时效报表.xlsx");
        this.$DonMessage.success("导出成功！");
      } finally {
        this.exportLoading = false;
        this.btnLoading = false;
      }
    },
    // () {
    //   const data = this.tableData;
    //   // if (data.length === 0) {
    //   //   this.$DonMessage.warning("暂无数据可导出");
    //   //   return;
    //   // }

    //   const columns = [
    //     { prop: "questionNum", label: "序号", parent: null },
    //     { prop: "feedbackFormId", label: "反馈单号", parent: null },
    //     { prop: "area", label: "地区", parent: null },
    //     { prop: "country", label: "国家", parent: null },
    //     { prop: "questionContent", label: "故障描述", parent: null },
    //     { prop: "creator", label: "反馈人", parent: null },
    //     {
    //       prop: "submitTime",
    //       label: "反馈时间",
    //       parent: {
    //         label: "",
    //         subtitle: "服务经理提交时间",
    //       },
    //     },
    //     {
    //       prop: "responseTime",
    //       label: "反馈时间",
    //       parent: {
    //         label: "技术经理",
    //         subtitle: "类型判定时效-服务经理反馈时间",
    //       },
    //     },
    //     {
    //       prop: "outputTime",
    //       label: "临时措施输出时效",
    //       parent: {
    //         label: "质量改善部",
    //         subtitle: "质量改善部C输出时间-类型判定时间",
    //       },
    //     },
    //     {
    //       prop: "technologyManagerAffirmTime",
    //       label: "临时措施输出时效",
    //       parent: {
    //         label: "技术经理",
    //         subtitle: "技术经理审核时间-质量改善部C输出时间",
    //       },
    //     },
    //     {
    //       prop: "technologyExpertAffirmTime",
    //       label: "临时措施确定时效",
    //       parent: {
    //         label: "技术专家",
    //         subtitle: "技术专家审核时间-技术经理审核时间",
    //       },
    //     },
    //     {
    //       prop: "serveAffirmTime",
    //       label: "临时措施确定时效",
    //       parent: {
    //         label: "服务经理",
    //         subtitle: "服务经理填写验证说明时间-技术专家审核的时间",
    //       },
    //     },
    //     {
    //       prop: "rootCauseAnalysisOutputTime",
    //       label: "根因分析输出时效",
    //       parent: {
    //         label: "质量改善部",
    //         subtitle: "类质量改善部C输出根因分析时间-服务经理填写验证说明时间",
    //       },
    //     },
    //     {
    //       prop: "managerRootCauseAnalysisAffirmTime",
    //       label: "根因分析确定时效",
    //       parent: {
    //         label: "技术经理",
    //         subtitle: "技术经理审核根因时间-质量改善部C输出根因时间",
    //       },
    //     },
    //     {
    //       prop: "expertRootCauseAnalysisAffirmTime",
    //       label: "根因分析确定时效",
    //       parent: {
    //         label: "技术专家",
    //         subtitle: "技术专家审核根因时间-技术经理审核根因时间",
    //       },
    //     },
    //     {
    //       prop: "departmentPermanentMeasureAffirmTime",
    //       label: "永久措施确定时效",
    //       parent: {
    //         label: "质量改善部",
    //         subtitle: "质量改善部C输出永久措施时间-输出根因分析时间",
    //       },
    //     },
    //     {
    //       prop: "managerPermanentMeasureAffirmTime",
    //       label: "永久措施确定时效",
    //       parent: {
    //         label: "技术经理",
    //         subtitle: "技术经理审核永久措施时间-质量改善部C输出永久措施时间",
    //       },
    //     },
    //     {
    //       prop: "expertPermanentMeasureAffirmTime",
    //       label: "永久措施确定时效",
    //       parent: {
    //         label: "技术专家",
    //         subtitle: "技术专家审核永久措施时间-技术经理审核永久措施时间",
    //       },
    //     },
    //     {
    //       prop: "marketValidationTime",
    //       label: "市场验证时间",
    //       parent: {
    //         label: "服务经理",
    //         subtitle: "市场新到车辆市场验证确认时间-永久措施输出时间",
    //       },
    //     },
    //   ];

    //   // 构建三行表头
    //   const headerRow1 = []; // 一级表头
    //   const headerRow2 = []; // 二级说明
    //   const headerRow3 = []; // 三级列名

    //   columns.forEach((col) => {
    //     if (col.parent) {
    //       headerRow1.push(col.parent.label);
    //       headerRow2.push(col.parent.subtitle);
    //       headerRow3.push(col.label);
    //     } else {
    //       headerRow1.push("");
    //       headerRow2.push("");
    //       headerRow3.push(col.label);
    //     }
    //   });

    //   // 前6列一级表头为空
    //   for (let i = 0; i < 6; i++) {
    //     headerRow1[i] = "";
    //   }

    //   // 创建工作表数据（二维数组）
    //   const worksheetData = [
    //     headerRow1,
    //     headerRow2,
    //     headerRow3,
    //     ...data.map((row) => columns.map((col) => row[col.prop])),
    //   ];

    //   // 创建工作簿
    //   const ws = XLSX.utils.aoa_to_sheet(worksheetData);

    //   // 设置列宽（可选）
    //   ws["!cols"] = columns.map(() => ({ wch: 20 }));

    //   // 创建工作簿并导出
    //   const wb = XLSX.utils.book_new();
    //   XLSX.utils.book_append_sheet(wb, ws, "时效报表");

    //   // 导出文件
    //   XLSX.writeFile(wb, "时效报表数据.xlsx");
    // },
  },
};
</script>
<style src="@/assets/css/qualityStyle.css"></style>
<style lang="scss" scoped>
</style>
